<template>
    <div>
        <pageHead :title="title" :btn-list="btnList" @handleBtn="handleBtn"></pageHead>
        <div class="content">
            <div class="search">
                <Form>
                    <row :gutter="80">
                        <i-col span="8">
                            <FormItem label="出租方">
                                <div class="detail">{{info.leasor}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="出租方证件号">
                                <div class="detail">{{info.leasorCode}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="出租方联系方式">
                                <div class="detail">{{info.leasorTel}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="出租方住址">
                                <div class="detail">{{info.leasorAddress}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="承租方">
                                <div class="detail">{{info.leasee}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="承租方证件号">
                                <div class="detail">{{info.leaseeCode}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="承租方联系方式">
                                <div class="detail">{{info.leaseeTel}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="租金">
                                <div class="detail">{{info.zj}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="面积">
                                <div class="detail">{{info.zlmj}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="租赁用途">
                                <div class="detail">{{info.zlyt}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="房屋坐落">
                                <div class="detail">{{info.houseAddress}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="不动产单元号">
                                <div class="detail">{{info.estateUnitNO}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="租赁开始时间">
                                <div class="detail">{{info.compactStartdate | formatData}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="租赁结束时间">
                                <div class="detail">{{info.compactEnddate | formatData}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="合同">
                                <a class="detail" style="color: #57a3f3;" title="点击下打开租赁合同" :href="info.fileUrl" target="_blank">租赁合同</a>
                            </FormItem>
                        </i-col>
                    </row>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
import miment from "miment";
const {
    getFwzlxx
} = api
export default {
    name: "leaseContractDetail",
    components: {
        pageHead
    },
    filters: {
        formatData(value){
            return miment(Number(value)).format("YYYY-MM-DD")
        }
    },
    data() {
        return {
            title: "租赁合同",
            btnList: [],
            info: []
        }
    },
    methods: {
        handleBtn(){

        },
        async getDetail() {
            try {
                let res = await this.$get(getFwzlxx, {
                    id: this.$route.query.id
                });
                if (res.isSucceed && res.rows) {
                    this.info = res.rows[0];
                }
            } finally {}
        }
    },
    created(){
        this.getDetail()
    }
}
</script>

<style lang="less" scoped>
.content {
    margin: 20px;
}

.search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 20px;
}

.detail {
    color: #666;
}
</style>